import Ctverec from './Ctverec';
import CtverecProKresleni from './CtverecProKresleni';
import View from './View';

export default class Model {
	ctverec: Ctverec = new Ctverec();
	private vykreslit: CtverecProKresleni[] = [];
	private view = new View(this.vykreslit);
	private pocetNovychCtvercu: number = 10;
	private pravdepodobnostZmenyBarvy: number = 0.5;

	constructor() {
		setInterval(() => {
			this.smycka();
		}, 1000 / 60);
		this.view.kresli();
	}

	smycka(): void {
		for (let i = 0; i < this.pocetNovychCtvercu; i++) {
			this.ctverec.posun();
			this.zmenBarvu();
			this.vykreslit.push(this.ctverec.vytvorCtverecProKresleni());
		}
	}

	zmenBarvu(): void {
		const barvy = [ '#213536', '#48665A', '#628C5F', '#E1E2AB', '#A4BB83' ];
		if (Math.random() < this.pravdepodobnostZmenyBarvy) this.ctverec.zmenBarvu(barvy[Math.floor(Math.random() * barvy.length)]);
	}

	nastavPocetNovychCtvercu(pocet: number): void {
		this.pocetNovychCtvercu = pocet;
	}

	nastavpravdepodobnostZmenyBarvy(zmenaProcenta: number): void {
		this.pravdepodobnostZmenyBarvy = zmenaProcenta;
	}
}
